import { useAccount } from "@vojomo-core/shared";
import BaseLayout from "../layouts/BaseLayout";

export function Home(): React.ReactElement {
  const { vojomoAccount } = useAccount();

  return (
    <BaseLayout>
      <div>
        <h3>Welcome to the Vojomo Admin Application.</h3>
        <br />
        <strong>Name</strong>: {vojomoAccount.name}
        <br />
        <strong>Email</strong>: {vojomoAccount.email}
      </div>
    </BaseLayout>
  );
}
